import { action as apiAction } from 'api/Api'
import {
  set as setElement,
} from '../redux/elements'
import { optimisticDispatch } from 'utils/sagas'

type Payload = {
  cardId: number;
  documentFolderCreatorId: number;
  settings: any
}

const requestChangeDocumentFolderCreatorSettings = (payload: Payload) => async (dispatch, getState) => {
  const { cardId, documentFolderCreatorId, settings } = payload

  const currentSettings = getState()['view-card'].elements.elementsById[documentFolderCreatorId]?.settings

  const newSettings = {
    ...currentSettings,
    ...settings,
    FolderSettings: {
      ...currentSettings.FolderSettings,
      ...settings.FolderSettings,
    }
  }

  const optimisticAction = optimisticDispatch(dispatch, setElement({
    cardId,
    element: {
      id: documentFolderCreatorId,
      settings: newSettings,
    }
  }))

  try {
    await apiAction('ChangeDocumentFolderCreatorSettings', {
      documentsFolderCreatorId: documentFolderCreatorId,
      settings: newSettings
    })

    optimisticAction.commit()
  } catch (error) {
    optimisticAction.revert()

    throw error
  }
}

export default requestChangeDocumentFolderCreatorSettings